module.exports = __webpack_public_path__ + "static/media/Rules-dictionary-implementation2.012b075b.pdf";